<template>
<div class="foodWarehouseInfo"  >
    <div class="top"> 
           <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button> 
            <el-button type="primary" size="medium" @click="foodWarehouseeidt()">编辑</el-button>
    </div>
    <div class="subject" :style="`height: ${windowHeight-180}px;`">
      <div class="body">
         <el-form  label-width="150px" class="demo-ruleForm">
               <el-form-item label="食材名称">
                   {{myobj.name}}              
                </el-form-item>
                <el-form-item label="分类">
                   {{myobj.typeName}}              
                </el-form-item>
                <el-form-item label="食部">
                   {{myobj.foodPart}} %             
                </el-form-item>
                <el-form-item label="能量">
                   {{myobj.energy}} 卡路里            
                </el-form-item>
                <el-form-item label="蛋白质">
                   {{myobj.protein}} g       
                </el-form-item> 
                <el-form-item label="脂肪">
                   {{myobj.fat}} g       
                </el-form-item>
                <el-form-item label="碳水化合物">
                   {{myobj.carbohydrate}} g       
                </el-form-item>  
                <el-form-item label="维生素A">
                   {{myobj.vitaminA}} mg       
                </el-form-item>
                <el-form-item label="硫胺素(维生素B1)" >
                   {{myobj.vitaminB1}} mg       
                </el-form-item> 
                <el-form-item label="核黄素(维生素B2)" >
                   {{myobj.vitaminB2}} mg       
                </el-form-item> 
                <el-form-item label="维生素C" >
                   {{myobj.vitaminC}} mg       
                </el-form-item>                   
                <el-form-item label="维生素E" >
                   {{myobj.vitaminE}} mg       
                </el-form-item>
                <el-form-item label="钙" >
                   {{myobj.ca}} mg       
                </el-form-item>
                <el-form-item label="铁" >
                   {{myobj.fe}} mg       
                </el-form-item>
                <el-form-item label="锌" >
                   {{myobj.zn}} mg       
                </el-form-item>
                <el-form-item label="图片" v-if="myobj.pic">
                   <image-previewer tag="richtext"><img class="picimg" :src="myobj.pic" alt=""></image-previewer>       
                </el-form-item>
        </el-form>
      </div>
    </div>    
</div> 
</template>
<script>
import {materialDetails} from "@/api/foodSetting";
import mixin from "@/mixins/windowResize";
import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer';
export default {
  data() {
    return {
     id:this.$route.query.id,
     myobj:{
        ca:'',//	钙	string	
        carbohydrate:'',//	碳水化合物	string	
        energy:'',//	能量	string	
        fat:'',//	脂肪	string	
        fe:'',//	铁	string	
        foodPart:'',//	食部	number	
        name:'',//	食材名称	string	
        pic:'',//	图片，可空	string	
        protein:'',//	蛋白质	string	
        typeId:'',//	类型Id	number	
        typeName:'',//	类型名称	string	
        vitaminA:'',//	维生素A	string	
        vitaminB1:'',//	维生素B1	string	
        vitaminB2:'',//	维生素B2	string	
        vitaminC:'',//	维生素C	string	
        vitaminE:'',//	维生素E	string	
        zn:'',//	锌	string	
     }
    };
  },
  mixins: [mixin],
  components: {ImagePreviewer},
  created() {
     this.materialDetailss();
  },
  methods: {
     materialDetailss(){
       materialDetails(this.id).then(res => res.data).then(data => {
          if(data.code==200){
            let mydata=data.data;
            this.myobj=mydata;
          }     
       })
     },
   
     //编辑
     foodWarehouseeidt(){
         this.$router.push({
        path: "foodWarehouseeidt",
        query: {
          id: this.id
        }
      });
     }
  }
};
</script>
<style lang="scss" scoped>
.foodWarehouseInfo {
   padding: 12px;
  .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
    overflow: hidden;
  }
  .subject {
    padding-top: 10px;
    overflow: auto;
    .body{
      width: 810px;
      margin: 0 auto;
      .demo-ruleForm {
      overflow: hidden;
      .el-form-item {
        width: 50%;
        float: left;
        margin-bottom: 5px;
        .picimg{
            height:40px ;
        }
        }
      }
      
    }    
  }   
}
</style>


// WEBPACK FOOTER //
// src/views/foodSetting/foodWarehouseInfo.vue